import React from 'react';

const CardApple = ({
  children,
  className = '',
  hover = true,
  ...props
}) => {
  return (
    <div 
      className={`apple-card ${hover ? '' : 'hover:shadow-sm'} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

const CardHeader = ({ children, className = '', actions }) => {
  return (
    <div className={`apple-card-header ${className}`}>
      <div className="flex-1">{children}</div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
};

const CardTitle = ({ children, className = '' }) => {
  return (
    <h3 className={`apple-card-title ${className}`}>{children}</h3>
  );
};

const CardBody = ({ children, className = '' }) => {
  return (
    <div className={`apple-card-body ${className}`}>{children}</div>
  );
};

const CardFooter = ({ children, className = '' }) => {
  return (
    <div className={`apple-card-footer ${className}`}>{children}</div>
  );
};

CardApple.Header = CardHeader;
CardApple.Title = CardTitle;
CardApple.Body = CardBody;
CardApple.Footer = CardFooter;

export default CardApple;
